import React from "react";
import styled from "@emotion/styled";
import { Advertisement } from "../../lib/types";
import BottomBannerSlot from "./BottomBannerSlot";
import AdFooter from "./AdFooter";
import QRCode from "../QRCode";

const BannerContainer = styled.div<{ visible: boolean }>`
  position: fixed;
  bottom: 50px;
  left: 50%;
  display: flex;
  flex-direction: column;
  transform: translateX(-50%);
  opacity: ${(props) => (props.visible ? 1 : 0)};
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: row;
  background: white;
`;

const QRCodeContainer = styled.div`
  width: 90px;
  height: 90px;
  overflow: hidden;

  > div {
    transform: scale(0.5) translateX(-50%) translateY(-50%);
  }
`;

type Props = {
  visible: boolean;
  willDisappear: boolean;
  advertisement: Advertisement;
  onReady: () => void;
};

const Ad: React.FC<Props> = ({ visible, advertisement, onReady }) => {
  React.useEffect(() => {
    onReady();
  }, []);

  if (advertisement.data.slot === "banner") {
    return (
      <BannerContainer visible={visible}>
        <BannerContent>
          <BottomBannerSlot media={advertisement.data.media} />
          <QRCodeContainer>
            <QRCode data={advertisement.data.url} color="#1a2e59" size={180} />
          </QRCodeContainer>
        </BannerContent>
        <AdFooter duration={advertisement.data.duration} />
      </BannerContainer>
    );
  }

  return null;
};

export default Ad;
